import { positionsSearchSchema } from "@blockdaemon/widget-host";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";

export const Route = createFileRoute("/_layout/defi/positions")({
  component: () => <Outlet />,
  validateSearch: zodValidator(positionsSearchSchema),
});
